var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAmber24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583008 12.2501L6.99967 1.16675L13.4163 12.2501H0.583008ZM11.3922 11.0834L6.99967 3.49425L2.60717 11.0834H11.3922ZM6.41634 9.33341V10.5001H7.58301V9.33341H6.41634ZM6.41634 5.83342H7.58301V8.16675H6.41634V5.83342Z",
    fill: "#B00808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber24Px);
export default __webpack_public_path__ + "static/media/warning_amber_24px.ae8226e6151202ac90a83746df47764d.svg";
export { ForwardRef as ReactComponent };